// Import necessary action types, HttpService, and Post function
import {
  POSTMORE_FETCH_DATA_SUCCESS,
  POSTMORE_HAVE_ERROR,
  POSTMORE_ARE_LOADING,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Post } from "../../services/api.service";

// Action creator function to handle different types of post actions
export function PostMoreAction(action, payload) {
  switch (action) {
    case POSTMORE_HAVE_ERROR:
      // Return action object indicating error
      return {
        type: action,
        hasError: payload,
      };

    case POSTMORE_ARE_LOADING:
      // Return action object indicating loading state
      return {
        type: action,
        isLoading: payload,
      };

    case POSTMORE_FETCH_DATA_SUCCESS:
      // Return action object containing fetched post data
      return {
        type: action,
        Post: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch post data based on provided URL
export function PostMoreFetchData(url) {
  return (dispatch) => {
    // Dispatch action to indicate data loading
    dispatch(PostMoreAction(POSTMORE_ARE_LOADING, true));
    // Make a POST request to fetch post data based on provided URL
    return Post(HttpService.postMore, { url: url})
      .then((result) => {
        console.log("PostMore API Payload:", { url: url});
        console.log("PostMore API Result:", result);

        // Determine the correct data structure
        let dataToPass = [];
        if (result && Array.isArray(result)) {
           dataToPass = result;
        } else if (result && result.data && Array.isArray(result.data)) {
           dataToPass = result.data;
        } else if (result && typeof result === 'object') {
           // Try to find valid array in other common keys if not in .data
           if (Array.isArray(result.items)) dataToPass = result.items;
           else if (Array.isArray(result.posts)) dataToPass = result.posts;
           else dataToPass = result; // Pass the whole object and let reducer handle or fail gracefull
        }

        // Dispatch success action with fetched post data and page number
        dispatch(PostMoreAction(POSTMORE_FETCH_DATA_SUCCESS, { data: dataToPass}));
        // Resolve the promise with the result
        return result;
      })
      .catch((error) => {
        console.error("PostMore API Error:", error);
        // Dispatch error action if request fails and reject the promise
        dispatch(PostMoreAction(POSTMORE_HAVE_ERROR, true));
        return Promise.reject(error);
      });
  };
}
